// A small bar per publisher or topic, biggest first.
export const ListenBars = ({ title, rows, testid }) => {
  if (!rows?.length) return null;
  const top = Math.max(...rows.map((r) => r.minutes)) || 1;

  return (
    <div data-testid={testid}>
      <p className="text-[10px] font-semibold uppercase tracking-widest text-ink-soft">{title}</p>
      <ul className="mt-1.5 space-y-1">
        {rows.map((row) => (
          <li key={row.name} className="flex items-center gap-2 text-[11px]"
              data-testid={`${testid}-${row.name.replace(/\W+/g, "-").toLowerCase().slice(0, 24)}`}>
            <span className="w-28 shrink-0 truncate text-ink" dir="auto" title={row.name}>{row.name}</span>
            <span className="h-1.5 min-w-[3px] rounded-full bg-brand/70"
                  style={{ width: `${Math.max(4, (row.minutes / top) * 100)}%` }} />
            <span className="shrink-0 tabular-nums text-ink-soft">
              {row.minutes} min · {row.times}×
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
